///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0, new-cap:0,prefer-arrow-callback:0,comma-dangle:0,
no-multi-spaces:0,keyword-spacing:0,no-shadow:0,object-shorthand:0,global-require:0,no-inner-declarations:0,no-redeclare:0,
no-param-reassign:0,no-extra-semi:0,consistent-return:0,wrap-iife:0 */
/* global AUTOBAHN_DEBUG:true */

var util = require('../util.js');
var serializer = require('../serializer.js');

function Factory (options) {
    var self = this;

    util.assert(typeof options.url !== 'undefined', "options.url missing");
    util.assert(typeof options.url === "string", "options.url must be a string");

    if (!options.serializers) {
        options.serializers = [new serializer.JSONSerializer()];
    } else {
        util.assert(Array.isArray(options.serializers), "options.serializers must be an array");
    }

    if (!options.protocols) {
        options.protocols = [];
        options.serializers.forEach(function (ser) {
            options.protocols.push("wamp.2." + ser.SERIALIZER_ID);
        });
    } else {
        util.assert(Array.isArray(options.protocols), "options.protocols must be an array");
    }

    self._options = options;
}


Factory.prototype.type = "websocket";


Factory.prototype.create = function () {

    var self = this;

    // the WAMP transport we create
    var transport = {};

    // these will get overridden by the WAMP session using this transport
    transport.onmessage = function () {};
    transport.onopen = function () {};
    transport.onclose = function () {};

    transport.info = {
        type: 'websocket',
        url: self._options.url,
        protocol: null
    };



    //
    // running in the browser
    //
    (function () {

        var websocket;

        // Chrome, MSIE, newer Firefox
        if ("WebSocket" in window) {

            if (self._options.protocols) {
                websocket = new global.WebSocket(self._options.url, self._options.protocols);
            } else {
                websocket = new global.WebSocket(self._options.url);
            }
            websocket.binaryType = 'arraybuffer';

            // older versions of Firefox prefix the WebSocket object
        } else if ("MozWebSocket" in window) {

            if (self._options.protocols) {
                websocket = new global.MozWebSocket(self._options.url, self._options.protocols);
            } else {
                websocket = new global.MozWebSocket(self._options.url);
            }
        } else {
            throw "browser does not support WebSocket or WebSocket in Web workers";
        }

        websocket.onmessage = function (evt) {

            var msg = transport.serializer.unserialize(evt.data);
            transport.onmessage(msg);
        }

        websocket.onopen = function () {
            var serializer_part = websocket.protocol.split('.')[2];
            for (var index in self._options.serializers) {
                var serializer = self._options.serializers[index];
                if (serializer.SERIALIZER_ID == serializer_part) {
                    transport.serializer = serializer;
                    break;
                }
            }

            transport.info.protocol = websocket.protocol;
            transport.onopen();
        }

        websocket.onclose = function (evt) {
            var details = {
                code: evt.code,
                reason: evt.message,
                wasClean: evt.wasClean
            }
            transport.onclose(details);
        }

        // do NOT do the following, since that will make
        // transport.onclose() fire twice (browsers already fire
        // websocket.onclose() for errors also)
        //websocket.onerror = websocket.onclose;

        transport.send = function (msg) {
            var payload = transport.serializer.serialize(msg);
            websocket.send(payload);
        }

        transport.close = function (code, reason) {
            websocket.close(code, reason);
        };

    })();


    return transport;
};



exports.Factory = Factory;



// WEBPACK FOOTER //
// ./src/lightweight-autobahn/src/transport/websocket.js